import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "./AdminAuth";
import { AdminLogin } from "./AdminLogin";
import { AdminLayout } from "./AdminLayout";
import { Dashboard } from "./Dashboard";
import { ArticlesPage } from "./ArticlesPage";
import { ArticleEditorPage } from "./ArticleEditorPage";
import { MessagesPage } from "./MessagesPage";
import { DeletionRequestsPage } from "./DeletionRequestsPage";
import { AndroidWaitlistPage } from "./AndroidWaitlistPage";
import { Spinner } from "./ui";
import { Toaster } from "@/components/ui/sonner";

const RequireAuth = ({ children }) => {
    const { user } = useAdminAuth();
    if (user === undefined) return <div className="min-h-screen bg-[#052536]"><Spinner testId="admin-auth-checking" /></div>;
    if (!user) return <Navigate to="/login" replace state={{ from: window.location.pathname }} />;
    return children;
};

const Page = ({ children }) => (
    <RequireAuth>
        <AdminLayout>{children}</AdminLayout>
    </RequireAuth>
);

export default function AdminApp() {
    useEffect(() => {
        document.title = "Admin | TheraOffice";
        let meta = document.querySelector('meta[name="robots"]');
        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "robots");
            document.head.appendChild(meta);
        }
        meta.setAttribute("content", "noindex, nofollow");
    }, []);

    return (
        <AdminAuthProvider>
            <BrowserRouter basename="/admin">
                <Routes>
                    <Route path="/login" element={<AdminLogin />} />
                    <Route path="/" element={<Page><Dashboard /></Page>} />
                    <Route path="/articles" element={<Page><ArticlesPage /></Page>} />
                    <Route path="/articles/new" element={<Page><ArticleEditorPage /></Page>} />
                    <Route path="/articles/:id" element={<Page><ArticleEditorPage /></Page>} />
                    <Route path="/messages" element={<Page><MessagesPage /></Page>} />
                    <Route path="/deletion-requests" element={<Page><DeletionRequestsPage /></Page>} />
                    <Route path="/android" element={<Page><AndroidWaitlistPage /></Page>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Toaster position="bottom-center" theme="dark" />
            </BrowserRouter>
        </AdminAuthProvider>
    );
}
